module.exports = __webpack_public_path__ + "static/media/line-spacing.aa4d0947.svg";